import { Dispatch, SetStateAction } from 'react';
import FormActionButtonLayout from '../../../components/layout/Form/FormActionButtonLayout';
import { Button, Box } from '@mui/material';
import { IOmekaResp } from '../Registrations/RegistrationOrganisation';
import { VerticalStep, VerticalStepper } from '../../../components/Stepper';
import { House } from '@mui/icons-material';
import LinesSkeleton from '../../../components/Skeletons/LinesSkeleton';
import Details from '../../../components/Details/Details';
import { useSearchParams } from 'react-router-dom';
import { Formik } from 'formik';
import { initialValuesEditForeas } from '../Registrations/types';
import { editOrganisationValidation } from '../Registrations/validationSchema';
import { renderErrors } from '../../../components/form_v2/helpers';
import { isSubmitEnabled } from '../../../lib/helperFuncs';

interface IPreviewForeas {
  setRenderPreview: Dispatch<SetStateAction<boolean>>;
  onSubmit: (values: any) => Promise<void>;
  data: IOmekaResp | Record<string, never>;
  isLoading?: boolean;
}

const PreviewForeas = ({
  setRenderPreview,
  onSubmit,
  data,
  isLoading
}: IPreviewForeas) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const basic_info_details = [
    {
      name: 'Μοναδικός Κωδικός Φορέα',
      value: data.organisationsUniqueCode || '-',
      refValue: 'organisationsUniqueCode'
    },
    {
      name: 'Aναγνωριστικό Φορέα',
      value: data.orgIdentifierCountryId || '-',
      refValue: 'orgIdentifierCountryId'
    },
    {
      name: 'Επωνυμία Φορέα',
      value: data.organisationsName || '-',
      refValue: 'organisationsName'
    },
    {
      name: 'Συντομογραφία Φορέα',
      value: data.organisationsAbbreviation || '-',
      refValue: 'organisationsAbbreviation'
    },
    {
      name: 'Επωνυμία Φορέα English',
      value: data.organisationsEnNameEn || '-',
      refValue: 'organisationsEnNameEn'
    },
    {
      name: 'Συντομογραφία Φορέα English',
      value: data.orgIdentifierEnAbbreviation || '-',
      refValue: 'orgIdentifierEnAbbreviation'
    },
    {
      name: 'Παρατηρήσεις Σχόλια Φορέα',
      value: data.orgIdentifierComments || '-',
      refValue: 'orgIdentifierComments'
    },
    {
      name: 'Παρατηρήσεις Σχόλια Φορέα English',
      value: data.orgIdentifierCommentsEn || '-',
      refValue: 'orgIdentifierCommentsEn'
    },
  ];
  const address_info = [
    {
      name: 'Email Φορέα',
      value: data.organisationsEmail || '-',
      refValue: 'organisationsEmail'
    },
    {
      name: 'Website Φορέα',
      value: data.organisationsWebsite || '-',
      refValue: 'organisationsWebsite'
    },
    {
      name: 'Τηλέφωνο Φορέα',
      value: data.organisationsTelephone || '-',
      refValue: 'organisationsTelephone'
    },
    {
      name: 'Διεύθυνση Φορέα',
      value: data.orgIdentifierFullAddress || '-',
      refValue: 'orgIdentifierFullAddress'
    },
    {
      name: 'Χώρα Φορέα',
      value: data.organisationsCountry || '-',
      refValue: 'organisationsCountry'
    },
  ];

  const basicInfo = <Box
    display='flex'
    justifyContent='flex-start'
  >
    <Box width='fit-content'>
      {isLoading
        ? <LinesSkeleton lines={basic_info_details.length} />
        : <Details
          removeLines
          rows={basic_info_details}
        />
      }
    </Box>
  </Box>;
  const addressInfo = <Box
    display='flex'
    justifyContent='flex-start'
    gap={15} >
    <Box sx={{width: 'fit-content'}}>
      {isLoading
        ? <LinesSkeleton lines={address_info.length} />
        : <Details
          removeLines
          rows={address_info}
        />
      }
    </Box>
  </Box>;

  const steps = [
    {
      label: 'Βασικές Πληροφορίες Φορέα',
      content: basicInfo,
      icon: <House />
    },
    {
      label: 'Στοιχεία Επικοινωνίας και Διεύθυνσης',
      content: addressInfo,
      icon: <House />
    }
  ];
  return (
    <>
      <VerticalStepper activeStep={0}>
        {steps.map(step => {
          return (
            <VerticalStep
              active={true}
              key={step.label}
              label={step.label}
              icon={step.icon}>
              {step.content}
            </VerticalStep>
          );
        })}
      </VerticalStepper>
      <Formik
        enableReinitialize
        onSubmit={() => undefined}
        initialValues={initialValuesEditForeas(data)}
        validationSchema={editOrganisationValidation}
        validateOnMount={true}
      >
        {formik =>
          (<>
            <Box ml={2} mt={3}>
              {renderErrors(formik.errors, [
                ...basic_info_details,
                ...address_info
              ])}
            </Box>
            <FormActionButtonLayout>
              <Button 
                variant='outlined' 
                color='error'
                onClick={() => {
                  setRenderPreview(false);
                  searchParams.delete('preview');
                  searchParams.set('edit', 'true');
                  setSearchParams(searchParams);
                }}
              > 
                Επιστροφή               
              </Button>
              <Button
                disabled={isSubmitEnabled(formik.errors, true)}
                variant='contained'
                onClick={() => onSubmit(data)}
              > 
                Υποβολή
              </Button>
            </FormActionButtonLayout>
          </>)}
      </Formik>
    </>
  );
};

export default PreviewForeas;